import { DripCustomEvent, DripStandardEvents } from '@xylabs/react-pixel'

interface CustomEventData extends Record<string, unknown> {
  offer: string
}

interface DripUserClickData extends CustomEventData {
  elementName: string
  elementType: string
}

export class DripEvents<T extends Record<string, unknown>> extends DripStandardEvents<T> {
  public testStarted() {
    return new DripCustomEvent<T>('track', 'TestStarted')
  }

  public emailCollected() {
    return new DripCustomEvent<CustomEventData | T>('track', 'EmailCollected')
  }

  public accountCreated() {
    return new DripCustomEvent<CustomEventData | T>('track', 'AccountCreated')
  }

  public shareCompleted() {
    return new DripCustomEvent<CustomEventData | T>('track', 'ShareCompleted')
  }

  public installCompleted() {
    return new DripCustomEvent<CustomEventData | T>('track', 'InstallCompleted')
  }

  public funnelCompleted() {
    return new DripCustomEvent<CustomEventData | T>('track', 'FunnelCompleted')
  }

  public trialStarted() {
    return new DripCustomEvent<CustomEventData | T>('track', 'TrialStarted')
  }

  public funnelStarted() {
    return new DripCustomEvent<CustomEventData | T>('track', 'FunnelStarted')
  }

  public userClick() {
    return new DripCustomEvent<DripUserClickData | T>('track', 'UserClick')
  }

  public purchase() {
    return new DripCustomEvent<{ value: number }>('track', 'F+S Purchase')
  }

  public customEvent(name: string) {
    return new DripCustomEvent<T>('track', name)
  }
}
